module.exports = __webpack_public_path__ + "static/hardkoder-630670531f98c631f40cbec550f7610b.svg";